import './ManageUsers.scss'
import './BrokerModal.scss'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { connectModal } from 'redux-modal'

import RemoveAgent from '../common/RemoveAgentModal'
import InviteAgents from './InviteAgents'
import InviteAdmins from './InviteAdmins'
import UsersList from './UsersList'
import TopNav from './TopNav'
import ConfirmResendModal from './ConfirmResendModal'
import ConfirmRemoveContactModal from './ConfirmRemoveContactModal'
import RemoveBrokerContactModal from './RemoveBrokerContactModal'
import ConfirmEditAgentExperienceModal from './ConfirmEditAgentExperienceModal'
import ConfirmEditAdminRoleModal from "./ConfirmEditAdminRoleModal";
import RemoveSuggestionFeedbackModal from './RemoveSuggestionFeedbackModal'
import EditInviteModal from './EditInviteModal'
import CancelInboundModal from './CancelInboundModal'
import { selectIsMasquerade } from 'common/redux/selectors/auth'

import {
  selectBrokerCompany,
  selectAgentInvitePreviewUrl,
  selectIsCore,
  selectIsBLA,
  selectIsMVIP,
  selectIsRCCOnly,
  selectBrokerAgentPopulationManagementEnabled,
  selectBrokerApmInviteExpirationEnabled
} from 'broker/selectors/account'

import { segmentManualPageTracker } from 'common/analytics'


const RemoveAgentModal = connectModal({ name: 'RemoveAgentModal', destroyOnHide: true })(RemoveAgent)

const PAGES = {
  USERS_LIST: 'USERS_LIST',
  INVITE_AGENTS: 'INVITE_AGENTS',
  INVITE_ADMINS: 'INVITE_ADMINS'
}

class ManageUsers extends Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: PAGES.USERS_LIST,
      previousPages: []
    }
  }

  onNavInviteAgents = () => {
    const { currentPage, previousPages } = this.state
    const pagesStack = [...previousPages]
    pagesStack.push(currentPage)
    this.setState({
      currentPage: PAGES.INVITE_AGENTS,
      previousPages: [...pagesStack]
    })
    segmentManualPageTracker('invite-agents')
  }

  onNavInviteAdmins = () => {
    const { currentPage, previousPages } = this.state
    const pagesStack = [...previousPages]
    pagesStack.push(currentPage)
    this.setState({
      currentPage: PAGES.INVITE_ADMINS,
      previousPages: [...pagesStack]
    })
    segmentManualPageTracker('invite-admins')
  }

  onNavBack = () => {
    const { previousPages } = this.state
    const pagesStack = [...previousPages]
    const previousPage = pagesStack.pop()
    this.setState({
      currentPage: previousPage,
      previousPages: [...pagesStack]
    })
  }

  render() {
    const { dispatch, is_core, is_mvip, is_rcc_only, is_bla, brokerAgentPopulationManagementEnabled, brokerApmInviteExpirationEnabled } = this.props
    const { currentPage } = this.state

    const userIsMasqueraded = selectIsMasquerade({...this.props})
    const InviteAgentsEnabled = is_core || is_mvip || is_bla || userIsMasqueraded

    return (
      <div>
        <div className='ManageUsers'>
          { currentPage === PAGES.USERS_LIST && (
            <div>
              <TopNav
                onClickInviteAgents={this.onNavInviteAgents}
                onClickInviteAdmins={this.onNavInviteAdmins}
                InviteAgentsEnabled={InviteAgentsEnabled}
              />
              <UsersList
                brokerAgentPopulationManagementEnabled={brokerAgentPopulationManagementEnabled}
                brokerAPMInviteExpirationEnabled={brokerApmInviteExpirationEnabled}
                isRCCOnly={is_rcc_only}
              />
            </div>
          )}
          { currentPage === PAGES.INVITE_AGENTS && (
            <InviteAgents
              handleBack={this.onNavBack}
              isCore={is_core}
              isMVIP={is_mvip}
              isRCCOnly={is_rcc_only}
              brokerApmInviteExpirationEnabled={brokerApmInviteExpirationEnabled}
            />
          )}
          { currentPage === PAGES.INVITE_ADMINS && (
            <InviteAdmins handleBack={this.onNavBack}/>
          )}
        </div>
        <ConfirmResendModal />
        <EditInviteModal />
        <CancelInboundModal />
        <RemoveAgentModal />
        <ConfirmRemoveContactModal />
        <RemoveBrokerContactModal />
        <ConfirmEditAgentExperienceModal  />
        <ConfirmEditAdminRoleModal />
        <RemoveSuggestionFeedbackModal dispatch={dispatch} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  company: selectBrokerCompany(state),
  agent_invite_preview_url: selectAgentInvitePreviewUrl(state),
  is_core: selectIsCore(state),
  is_mvip: selectIsMVIP(state),
  is_bla: selectIsBLA(state),
  is_rcc_only: selectIsRCCOnly(state),
  brokerAgentPopulationManagementEnabled: selectBrokerAgentPopulationManagementEnabled(state),
  brokerApmInviteExpirationEnabled: selectBrokerApmInviteExpirationEnabled(state),
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers)
